import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { EMediaType, ICategory } from '@shared/Types'
import { RouteKey } from '@internal/route'
import { CreateRoutePath } from '@lib/RouteBase'
import { Box, BoxProps, Chip, styled } from '@mui/material'
import { IExploreQueryParam } from '@shared/Services/QueryParamService'

interface IProps {
  data: ICategory[]
  mediaType?: EMediaType
}

export default class UICategories extends Component<IProps> {
  render() {
    if (this.props.data.length < 1) return <></>
    return (
      <ScrollWrap>
        <Box sx={{ display: 'flex', gap: '10px', height: '100%', alignItems: 'center' }}>
          {this.props.data.map((e, i) => {
            const explorePath = CreateRoutePath<IExploreQueryParam>(RouteKey.Explore, { query: { categories: e.Name, type: this.props.mediaType } })
            return <Chip key={i} label={e.Name || e.Id} variant='outlined' clickable {...{ component: Link, to: explorePath }} />
          })}
        </Box>
      </ScrollWrap>
    )
  }
}

const ScrollWrap = styled(({ children, ...p }: BoxProps) => (
  <Box {...p}>
    <Box>{children}</Box>
  </Box>
))({
  height: '42px',
  width: '100%',
  position: 'relative',
  '& > div': {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    overflowX: 'auto'
  },
  '& > div::-webkit-scrollbar': {
    width: '6px',
    height: '6px'
  }
})
